<template>
	<div>
		  <van-list
		    v-model="loading"
		    :finished="finished"
		    finished-text="没有更多"
		    @load="getmyorder"
		    offset="300"
		    :immediate-check="false"
		    ref="list"
		  >
		<div class="orderitem"
		v-for="(item, index) in myorder"
		:key="index"
		>
			<div class="ordermoney">订单金额：<span>{{(item.payPrice/100).toFixed(2)}}元</span></div>
			<div class="ordersn">订单编号：{{item.orderNumber}}</div>
			<div class="ordername">商品名称：{{item.orderName}}</div>
		</div>
		</van-list>
	</div>
</template>

<script>
		import { Toast } from 'vant';
		import {api_user} from '@/common/Request.js';
		var myordercallbackinfo=null;
		var mythis=null;
		export default {
	  data () {
	    return {
				myorder:'',
				usertoken:'',
				wxorderinfo:'',
				orderinfo_callback:'',
				openID:'',
				has_next:true,
				loading:false,
				finished:false,
				refreshing:true,
				pagesize:10,
				pageno:1
	    }
	  },
		mounted(){
			console.log(this.$cookies.isKey("user_token"));
			if(this.$cookies.isKey("user_token"))
			{
				this.usertoken=this.$cookies.get("user_token");
				this.getmyorder();
			}
		},
		methods: {
			getmyorder() {
				this.loading=true;
				api_user.order_list().then(response => {
			    console.log(response.data);
				const list =response.data;
				this.myorder=[...this.myorder,...list];
				this.loading=false;	
				this.finished=true;
			})
			.catch(function(error){
				console.log(error);
			})
				
			}
	},
}
</script>

<style lang="scss" scoped>
	.orderitem{
		border-radius: 0.625rem;
		box-shadow: 0 2px 6px rgba(100,100,100,0.5);
		margin: 1.25rem 0.625rem 0 0.625rem;
		color:#999999;
		font-size: 0.8rem;
		flex:1 1 100%;
		.ordermoney{
			border-bottom:solid 1px #eaeaea;
			height: 3rem;
			line-height: 3rem;
			padding-left: 1.25rem;
			position: relative;
			span{
				text-align: right;
				font-size: 1.2rem;
				font-weight: bolder;
				position: absolute;
				top:0;
				right:1.25rem;
				display: block;
				color:#666666
			}
		}
		.ordersn{
			padding-top:1.25rem;
			height: 1.5rem;
			line-height: 1.5rem;
			padding-left: 1.25rem;
		}
		.ordername{
			padding: 1.5rem 1.25rem 1.5rem 1.25rem;
			line-height: 1.5rem;
		}
		.paystatus{
			border-top:solid 1px #eaeaea;
			text-align: center;
			height: 3rem;
			line-height: 3rem;
			font-size: 1rem;
			font-weight: bolder;
		}
		.nopayed{
			color:#07c160;
		}
	}
</style>
